export default "__VITE_ASSET__D3PGW2SW__"